import {mapNeed} from '../basket/basket.service';
import {mapStockFacts} from '../shared/components/sm-stock-summary/stock-summary.model';
import {JournalEventDto} from './journal-event-dto';
import {JournalEvent} from './journal-event';

export function mapJournalEvent(dto: JournalEventDto): JournalEvent {
  return {id: dto.id, occurredAtUtc: dto.occurredAtUtc, eventType: dto.eventType,
    subjectType: dto.subjectType, subjectId: dto.subjectId, operationId: dto.operationId,
    actor: dto.actor ? {id: dto.actor.id, name: dto.actor.name} : null,
    historical: {name: dto.historical.name, changes: dto.historical.changes.map(change => ({field: change.field, before: change.before, after: change.after}))},
    current: dto.current ? {
      item: dto.current.item ? {...dto.current.item.data, ...mapStockFacts(dto.current.item.data), id: dto.current.item.id, containerId: dto.current.item.containerId, canEdit: dto.current.item.data.canEdit === true,
        containerPath: dto.current.item.data.containerPath.map(segment => ({id: segment.id, name: segment.name}))} : null,
      container: dto.current.container ? {...dto.current.container, canEdit: dto.current.container.canEdit === true} : null,
      need: dto.current.need ? mapNeed(dto.current.need) : null,
      purchase: dto.current.purchase ? {...dto.current.purchase} : null,
    } : null};
}
